import { Injectable } from '@angular/core';


@Injectable()
export class LocalStorageService {

    public set(key:string, value:string):void {
        localStorage.setItem(key, value);
    }

    public get(key:string):string {
        return localStorage.getItem(key);
    }

    public setObject(key:string, data:Object):void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    public getObject(key:string):any {
        return JSON.parse(localStorage.getItem(key));
    }

    public delete(key:string):void {
        localStorage.removeItem(key);
    }

    public hasKey(key:string):boolean {
        return !(localStorage.getItem(key) === null);
    }

    public clear():void {
        localStorage.clear();
    }

}


// WEBPACK FOOTER //
// ./src/app/services/localstorage.service.ts